import React from 'react';
import moment from "moment";

export const DateManager = (date) => {
    if (!date) return ''
    try {
        return moment(date).format('DD-MM-YYYY')
    } catch (e) {
        return date;
    }
};
export const DateManagerAddYear = (date) => {
    if (!date) return ''
    try {
        return moment(date).add(11, 'months').format('DD-MM-YYYY')
    } catch (e) {
        return date;
    }
};
export const DateManagerParse = (date) => {
    if (!date) return ''
    try {
        return moment(date).format('DD-MM-YYYY')
        // return moment(date).format('YYYY-MM-DD')
    } catch (e) {
        return date;
    }
};

export const DateYearSorted = (date) => {
    if (!date) return ''
    try {
        return moment(date).format('YYYY-MM-DD')
        // return moment(date).format('YYYY-MM-DD')
    } catch (e) {
        return date;
    }
};

export const DateTimeManagerParse = (date) => {
    if (!date) return ''
    try {
        return moment(date).format('DD-MM-YYYY hh:mm:ss')
    } catch (e) {
        return date;
    }
};

export const DateTimeManagerForDisable = (date) => {
    if (!date) return ''
    try {
        return moment(date).format('YYYY-MM-DDThh:mm')
    } catch (e) {
        return date;
    }
};


// manage true false
export const BlloeanHandler = (data) => {
    if (data == true)
        return 'Yes'
    else
        return 'No'
}


export const getAppPrimaryDateTimeFormat = (date) => {
    if (!date) return ''

    try {
        return moment(date).format('DD/MM/YY | HH:mm')
    } catch (e) {
        return date;
    }
}
